import { isEqual } from 'lodash'
import * as React from 'react'
import { connect } from 'react-redux'

import FormMessage, {
  FormMessageType,
} from 'components/FormMessage/FormMessage'
import { SRPRS } from 'Icon/srprs'
import { getExtrasPrices } from '../../../data/api/order'
import { FunnelOrder } from '../../../data/models/funnelOrder'
import { roomType } from '../../../data/models/funnelOrder/roomType'
import { SiteCountry, SiteCurrency } from '../../../data/models/locale'
import { AppState } from '../../../data/state'
import Content from '../../../pages/shared/content'
import AbstractTrigger from '../abstractTrigger'

interface HostelTriggerProps {
  roomType?: roomType
  funnelOrder: FunnelOrder
  country: SiteCountry
  currency: SiteCurrency
  numberOfMinors: number
}

interface HostelTriggerState {
  show: boolean
  price: number | null
}

class HostelTrigger extends AbstractTrigger<
  HostelTriggerProps,
  HostelTriggerState
> {
  private shown: boolean
  constructor(props: HostelTriggerProps) {
    super(props)
    this.state = {
      show: false,
      price: null,
    }
    this.shown = false
    this.getPrices()
  }

  public getPrices() {
    const { country, currency } = this.props
    const funnelOrder = Object.assign({}, this.props.funnelOrder)
    funnelOrder.roomType = roomType.budget
    getExtrasPrices(funnelOrder, country, currency).then(data => {
      const nrPeople = funnelOrder.numberOfAdults + funnelOrder.numberOfChildren
      const nrNights = funnelOrder.days - 1
      this.setState({ price: data.privateroom * nrPeople * nrNights })
    })
  }

  public updateShow(props: HostelTriggerProps) {
    if (this.state.price !== null && props.numberOfMinors > 0 && !this.shown) {
      this.shown = true
      this.setState({ show: true })
    }
  }

  public render() {
    return (
      <FormMessage
        type={FormMessageType.Info}
        show={this.state.show}
        icon={SRPRS.lightbulb}
        onClose={this.onClose}
      >
        <p>
          <Content
            contentKey="hostel-info-trigger"
            vars={{
              currency: this.props.currency,
              price: this.state.price ? this.state.price.toString() : '0',
            }}
          >
            {`There is someone younger than 18 on your trip.
                    Therefore, you must have a private room.
                    We have already selected this for you and it'll be ${this.props.currency} ${this.state.price}`}
          </Content>
        </p>
      </FormMessage>
    )
  }
}

export default connect((state: AppState) => ({
  funnelOrder: state.funnelOrder,
  country: state.locale.country,
  currency: state.locale.currency,
  numberOfMinors:
    state.funnelOrder.numberOfChildren + state.funnelOrder.numberOfBabies,
}))(HostelTrigger)
